import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ModalController, Events, ToastController} from 'ionic-angular';
import {Camera, CameraOptions} from '@ionic-native/camera';
import {ProfileCropPage} from '../profile-crop/profile-crop';
import {LoadingProvider} from '../../providers/loading/loading';
import {TransactionAlertProvider} from '../../providers/transaction-alert/transaction-alert';
import {RequestServiceProvider} from '../../providers/request-service/request-service';

/**
 * Generated class for the ProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})

export class ProfilePage {

  public profileImage;
  public croppedImage;
  public show = true;
  public profileInfo = JSON.parse(window.localStorage.getItem('agentObj'));
  public agentIncome = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, private camera: Camera,
              private modal: ModalController,
              private load: LoadingProvider,
              private alert: TransactionAlertProvider,
              private request: RequestServiceProvider,
              private event: Events,
              private toastCtrl: ToastController
  ) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProfilePage');
  }

  ionViewWillLoad() {
    this.load.presentLoading('loading...');
    this.request.getAgentProfileImg(window.localStorage.getItem('agentCode'))
      .subscribe(data => {
          this.load.loader.dismiss().catch(() => {
          });

          if (data.image_string == undefined) {
            this.show = true;
          } else {
            this.show = false;
            this.croppedImage = data.image_string;
          }
        },
        error => {
          this.load.loader.dismiss().catch(() => {});
        }
      );

    this.request.getAgentProfileInfo()
      .subscribe(data => {
          this.agentIncome = data;
        },
        error => {
          if (error.code = 403) {
            this.request.logout();
          }
        }
      )
  }

  agentPhotoSelfie() {
    const options: CameraOptions = {
      quality: 30,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      cameraDirection: this.camera.Direction.FRONT,
      correctOrientation: true
    };
    this.camera.getPicture(options).then((imageData) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64 (DATA_URL):
      this.profileImage = 'data:image/jpeg;base64,' + imageData;
      this.openModal();
      // this.show = false;
    }, (err) => {
      // Handle error
    });
  }

  test() {
    this.request.getAgentProfileInfo()
      .subscribe(data => {
        console.log(data);
      })
  }

  unusedVochers() {
    this.request.getUnusedVochers(4, 100).subscribe(
      data => {
        console.log(data);
      }
    )
  }

  openModal() {
    const profileModal = this.modal.create(ProfileCropPage, {data: this.profileImage});
    profileModal.present();
    profileModal.onDidDismiss(data => {
      this.croppedImage = data;

      let profileData = {
        agentCode: window.localStorage.getItem('agentCode'),
        image: this.croppedImage
      };

      this.event.publish('uploaded-image', this.croppedImage);

      this.request.postAgentProfile(profileData).subscribe(
        data => {
          this.presentToast();
        }
      );

      this.show = false;
    })
  }


  presentToast() {
    let toast = this.toastCtrl.create({
      message: 'Image Uploaded Sucessfully',
      duration: 3000,
      position: 'top'
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts